import config from "appConfig";
import { Slide } from "@jelly/lesson";

const soundMap: Record<string, string> = {};
for (let x = 0; x < 2; x++) {
  for (let y = 0; y < 3; y++) {
    for (let z = 0; z < 4; z++) {
      const id = [x, y, z].join(",");
      const zTag = ["Measurement", "Sim01", "Sim02", "Sim03"];
      const url = `${config.ASSETS_URL}/03/case-01/principle/Auralization_${zTag[z]}_Sound0${y + 1}.mp3`;
      soundMap[id] = url;
    }
  }
}

const principle: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 9],
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Room acoustics measurement and simulation of an existing space\n",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "CustomCase030105",
              options: {
                imageClarity: `${config.ASSETS_URL}/03/case-01/principle/5-clarity.png`,
                imageReverberation: `${config.ASSETS_URL}/03/case-01/principle/5-reverberation.png`,
                soundMap,
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
